<template>
  <div class="kids-gallery-detail" :class="{'kids-gallery-detail-mobile' : isMobile == 'mobile'}">
    <div class="navigation-title" style="margin-left: 0;margin-top: 0;"><span @click="()=>{$router.push('/kidsGallery')}">{{ $t('KidsGallery') }}</span> <i class="el-icon-arrow-right"></i> {{ $t(title) }}</div>
    <div>
      <el-row :gutter="20">
        <el-col :span="screenWidth <= 540?24:8" v-for="item in list" :key="item.id">
          <div class="kids-gallery-detail-list">
            <div style="padding: 1rem;">
              <el-image
                :class="{'kids-img' : isMobile =='mobile'}"
                style="width: 100%;border-radius: 1rem;height: 16rem;object-fit: cover;"
                :src="item.imgUrl" 
                :preview-src-list="[item.imgUrl]">
              </el-image>
              <!-- <img :src="item.imgUrl" alt="" style="width: 100%;"> -->
            </div>
            <div style="padding: 1rem 1rem;">
              <h3 style="margin-top: 0;">{{item.content}}</h3>
              <div>
                {{$t('Author')}}：{{item.name}}
              </div>
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
    <div class="bottom-pagination">
      <el-pagination small background layout="prev, pager, next" :total="page.total" @prev-click="preClick" @next-click="nextClick" @current-change="currentClick">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import {pageKids} from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      title: '基金会创始支持机构',
	  id:0,
	  page:{
		  page:1,
		  size:6,
		  total:100
	  },
      list: []
    };
  },
  mounted() {
    this.title = this.$route.query.title || '';
	  this.id = this.$route.query.id;
    this.pageKids(1,6);
  },
  methods:{
	  pageKids(page,size) {
	  		 pageKids({"page":page,"size":size,"moduleId":this.id}).then(res => {
	  		   if (res.data && res.data != null) {
	  		      this.list = res.data.records;
				      this.page.total = res.data.total;
	  		   }
	  		 })
	   },
     preClick(){
      this.page.page--;
     },
     currentClick(e){
      this.page.page = e;
      this.pageKids(this.page.page,this.page.size)
     },
     nextClick(){
      this.page.page++;
     }
  }
};
</script>

<style lang="less" scoped>
.kids-img{
  height: 20.5rem!important;
}
.kids-gallery-detail-mobile{
  padding: 2rem 8%!important;
  padding-top: 0;
  background-color: #ffffff;
  width: 84%!important;
}
.kids-gallery-detail {
  padding: 2rem 13%;
  padding-top: 0;
  background-color: #ffffff;
  width: 74%;
  .kids-gallery-detail-list {
    width: 100%;
    background-color: #ffffff;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-top: 2rem;
  }
}
a {
  text-decoration: none;
  color: black;
}
.bottom-pagination {
  width: 100%;
  height: 3rem;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-pagination.is-background .el-pager li{
  background-color: white;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: red;
}
</style>